import { useTranslation } from 'react-i18next'
import React from 'react'

import FolderSelect from '../../../../containers/folders/select/FolderSelect'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import FlexGrid from '../../../../components/structure/FlexGrid'

const FolderAndNameSection = () => {
  const { t } = useTranslation(['routines', 'common'])
  return (
    <FlexGrid justify="space-between" direction={'row'} align="start" ful>
      <div>
        <FormItem label={t('routines:nameRequired')} path={['name']} minWidth={20} />
      </div>
      <div>
        <FormItem label={t('routines:folder')} field={'folder'} Input={FolderSelect} />
      </div>
    </FlexGrid>
  )
}

export default FolderAndNameSection
